export default "./dist/stdassets/images/icons/print.png";